import { createContext } from 'react';

import type { HoneycombCustomTooltipConfig } from '../types/honeycomb-internal.js';

export const HoneycombCustomTooltipContext = createContext<
  HoneycombCustomTooltipConfig | undefined
>(undefined);
